/* eslint-disable prefer-promise-reject-errors */
import { FC, useCallback, useState, useEffect } from 'react';
import { Button, message, Upload } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import { useCustomInput, useLanguage } from '@/store';
import { $fm, $t } from '@/Intl';
import './CustomInput.less';
import * as API from '@/api';

// 上传本地图片
const CustomInput: FC<CustomFieldsProps> = (props) => {
  const { value, onChange } = props;
  const [custInput, setCustInput] = useCustomInput();
  const [, updateLanguage] = useLanguage();
  const [loading, setLoading] = useState(false);

  const beforeUpload = useCallback(
    (file: File) => {
      if (!/\.apk$/.test(file.name)) {
        message.error($t('UPLOAD_APK_ERROR'));
        return false;
      }
      setLoading(true);
      return API.apkAnalysis(file)
        .then((data) => {
          setCustInput(file);
          onChange && onChange(file.name);

          updateLanguage({
            custInputMethodName: file.name,
            custInputMethodInfoName: (data.inputMethodName || '').replace(
              data.packageName,
              data.packageName + '/',
            ),
            custInputMethodInfoPackageName: file.name,
          });
        })
        .catch((e) => {
          message.error('failed');
        })
        .finally(() => {
          setLoading(false);
          return Promise.reject();
        });
    },
    [setCustInput, onChange, updateLanguage],
  );

  const handleDelete = () => {
    setCustInput(null);
  };

  useEffect(() => {
    if (!custInput) {
      onChange && onChange('');
      updateLanguage({
        custInputMethodInfoName: '',
        custInputMethodInfoPackageName: '',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [custInput, updateLanguage]);

  return (
    <div className='cus-input-upload'>
      <Upload
        className='cus-input-upload-btn'
        beforeUpload={beforeUpload}
        showUploadList={false}
        accept='.apk'
      >
        <Button type='primary' loading={loading}>
          {$fm('UPLOAD')}
        </Button>
      </Upload>
      {value ? (
        <>
          <span className='cus-input'>{value}</span>
          <DeleteOutlined onClick={handleDelete} />
        </>
      ) : null}
    </div>
  );
};

export default observer(CustomInput);
